import { CSSObject, ButtonProps } from '@chakra-ui/react';
import { TTableText } from '../../../types';

export const TableItem: CSSObject = {
  borderBottom: '1px dashed',
  boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.07)',
  borderBottomColor: 'blackAlpha.400',
  borderRight: 'none',
  color: 'gamma.200',
  pl: 0,
  py: 2,
  'p:nth-of-type(1)': {
    fontWeight: 'bold',
  },
};
export const TableHeadingText: CSSObject = {
  color: 'gamma.200',
};
export const TransactionWrapper: CSSObject = {
  h: 'auto',
};
export const TableText = ({ textVariation }: TTableText): CSSObject => ({
  color: textVariation === 'positive' ? 'gamma.500' : 'gamma.200 ',
  fontSize: 'xs',
});
export const NoTransactionsText: CSSObject = {
  color: 'white',
};
export const buttonMoreTableProps: ButtonProps = {
  fontWeight: 'normal',
};
export const BoxTransactionsContainer: CSSObject = {
  ml: '1',
  color: 'gamma.200',
};
